import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const adminApi = axios.create({
  baseURL: API_BASE,
  timeout: 30000,
});

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers = config.headers || {};
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

adminApi.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      // Auto-logout on auth failure (except for the initial login call)
      const url = err.config?.url || '';
      if (!url.includes('/auth/login')) {
        localStorage.removeItem('admin_token');
        localStorage.removeItem('admin_user');
        if (window.location.pathname !== '/login') {
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(err);
  }
);

export function extractError(err) {
  if (!err) return 'Unknown error';
  if (err.response) {
    const d = err.response.data;
    if (typeof d === 'string') return d;
    if (d?.detail) {
      if (typeof d.detail === 'string') return d.detail;
      if (Array.isArray(d.detail)) {
        return d.detail.map((x) => x.msg || JSON.stringify(x)).join('; ');
      }
      return JSON.stringify(d.detail);
    }
    return `${err.response.status} ${err.response.statusText}`;
  }
  return err.message || 'Network error';
}
